import { validateServiceStep } from './bookingFlow'
import { updateRecommendations } from './updateRecommendations'

export function addClickEventForBookServiceButton() {
  let bookServicebuttons = document.querySelectorAll('.book-service-button');
  bookServicebuttons.forEach((e) => {
    e.addEventListener('click', validateServiceStep);
    e.addEventListener('click', updateRecommendations);
  });
}
